module.exports = __webpack_public_path__ + "static/media/logo_polar_white_collapsed.2be5fb8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo_polar_white_collapsed.png
// module id = 1531
// module chunks = 0